import React from 'react';
import Place from './subComponents/Place';
import Flight from './subComponents/Flight';
import SellDate from './subComponents/SellDate';

const GroupTripInfo: React.FC = () => {
    return (
        <>
            <SellDate />
            <Place />
            <Flight />
        </>
    );
};

export default GroupTripInfo;
